import store from '@/store';
import * as mt from '@/store/metadata/mutation-types';

export function toggleMarkerLabel() {
  store.dispatch(`metadata/${mt.TOGGLE_LABEL_MARKER}`);
}
